import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/')({
  staticData: {
    path: 'policy-violations',
    key: EntityTypeConfigKeys.PolicyViolation,
  },
  validateSearch: zodValidator(withDefaults(schema.POLICY_VIOLATIONS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
